import React, { useEffect, useState } from 'react';
import { BarChartIcon, HomeIcon, ListBulletIcon, PersonIcon } from '@radix-ui/react-icons';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useWindowSize } from 'helpers/useWindowSize';

const Navigation: React.FC = () => {
  const size = useWindowSize();
  const isVerySmall = size.width < 375;

  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener('keyboardDidShow', () => {
        setKeyboardOpen(true);
      });

      Keyboard.addListener('keyboardDidHide', () => {
        setKeyboardOpen(false);
      });
    }

    return () => {
      if (Capacitor.isNativePlatform()) {
        Keyboard.removeAllListeners();
      }
    };
  }, []);

  const navigationClassName = classNames(
    { 'text-sm ': !isVerySmall },
    { 'text-xs': isVerySmall },
    'md:text-base',
    'font-satoshi',
    'flex items-center self-stretch',
    { 'p-2': !isVerySmall },
    { 'p-0': isVerySmall },
    'md:p-1',
    { 'pb-4': Capacitor.isNativePlatform() },
    'left-0 md:left-auto',
    'right-0 md:right-auto',
    'fixed md:static',
    { 'hidden md:inline': keyboardOpen },
    'bottom-0 md:bottom-auto',
    'border border-t md:border-t-0 border-solid border-accent-accent-8',
    'bg-accent-accent-6',
    'rounded-b-none md:rounded-b-2xl rounded-t-2xl md:rounded-t-none',
    'z-10',
  );

  const buttonClassName = classNames(
    'flex',
    'justify-center',
    'flex-col md:flex-row',
    'items-center',
    'flex-1',
    'gap-2',
    'py-2 md:py-3',
    { 'px-6': !isVerySmall },
    { 'px-3': isVerySmall },
    'border',
    'border-solid',
    'border-accent-accent-6',
    'hover:bg-accent-accent-3',
    'hover:border-accent-accent-8',
    'hover:rounded-xl',
    'h-auto',
    'cursor-pointer',
  );
  return (
    <nav className={navigationClassName}>
      <Link to='/' className={buttonClassName}>
        <HomeIcon width='18' height='18' />
        Home
      </Link>
      <Link to='/classifiche' className={buttonClassName}>
        <BarChartIcon width='18' height='18' />
        Classifiche
      </Link>
      <Link to='/ricerca-competizioni' className={buttonClassName}>
        <ListBulletIcon width='18' height='18' />
        Tornei
      </Link>
      <Link to='/profilo' className={buttonClassName}>
        <PersonIcon width='18' height='18' />
        Profilo
      </Link>
    </nav>
  );
};

export default Navigation;
